import React from 'react';
import { Grid, InputLabel, OutlinedInput } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { GridPanel, dataGridDefaults } from '../../../components/list-grid-panel';
import { RowAction } from '../../../components/row-action';
import BudgetUnitAppService from '../../../application/platform/sge/budget-unit/budget-unit-app-service';
import { useArrayList } from '../../../hooks/use-array-list';
import { useBudgetUnitSearchController } from './context/budget-unit-search-controller';
import { useBudgetUnitSearchState } from './context/budget-unit-search-context';
import { BudgetUnitDrawer } from './components/budget-unit-drawer';

export function BudgetUnitSearchComponent() {
    const ctrl = useBudgetUnitSearchController();
    const { parameters, searchTrigger, drawer } = useBudgetUnitSearchState();
    const { rows, loading } = useArrayList(BudgetUnitAppService.list, parameters, searchTrigger, 'Não foi possível carregar as unidades orçamentárias');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'code', headerName: 'Código', width: 140 },
        { field: 'name', headerName: 'Nome', flex: 1, minWidth: 200 },
        { field: 'year', headerName: 'Exercício', width: 110 },
        {
            field: 'actions', headerName: 'Ações', width: 100, sortable: false,
            renderCell: (params) => (
                <React.Fragment>
                    <RowAction title="Editar" onClick={() => ctrl.openDrawer(params.row)}>
                        <EditIcon fontSize="small" />
                    </RowAction>
                    <RowAction title="Excluir" color="error" onClick={() => ctrl.handleDelete(params.row)}>
                        <DeleteIcon fontSize="small" />
                    </RowAction>
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Unidades Orçamentárias"
                    subtitle="Gerencie as unidades orçamentárias cadastradas"
                    breadcrumbs={[{ label: 'Unidades Orçamentárias' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={10}>
                        <InputLabel>Buscar por código ou nome</InputLabel>
                        <OutlinedInput fullWidth name="input-search" value={parameters.search || ''} onChange={ctrl.handleOnChange} onKeyDown={(e) => e.key === 'Enter' && ctrl.handleSearch()} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <InputLabel>Exercício</InputLabel>
                        <OutlinedInput fullWidth name="input-year" type="number" value={parameters.year ?? ''} onChange={ctrl.handleOnChange} inputProps={{ min: 2000, max: new Date().getFullYear() + 1 }} />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <GridPanel addLabel="Nova unidade orçamentária" onAdd={() => ctrl.openDrawer()}>
                    <DataGrid
                        {...dataGridDefaults}
                        rows={rows}
                        columns={columns}
                        loading={loading}
                        initialState={{ pagination: { paginationModel: { pageSize: 25, page: 0 } } }}
                    />
                </GridPanel>
            </Grid>

            <BudgetUnitDrawer
                open={drawer.open}
                initial={drawer.record}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
